var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasFeature && _vm.hasLeases && _vm.isMobile)?_c('InLifeFooter',{attrs:{"routes":_vm.routes,"create-options":_vm.createOptions},on:{"create":_vm.createAction}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }